import React from 'react';

import { node, string, oneOf, shape, oneOfType, number } from 'prop-types';

import Box from '@mui/material/Box';

const Flexbox = React.forwardRef(
  (
    {
      children,
      className,
      flexDirection,
      flexWrap,
      justifyContent,
      alignItems,
      alignContent,
      order,
      flexGrow,
      flexShrink,
      flexBasis,
      alignSelf,
      columnGap,
      rowGap,
      ...restProps
    },
    ref,
  ) => (
    <Box
      ref={ref}
      display="flex"
      className={className}
      flexDirection={flexDirection}
      flexWrap={flexWrap}
      justifyContent={justifyContent}
      alignItems={alignItems}
      alignContent={alignContent}
      order={order}
      flexGrow={flexGrow}
      flexShrink={flexShrink}
      flexBasis={flexBasis}
      alignSelf={alignSelf}
      columnGap={columnGap}
      rowGap={rowGap}
      {...restProps}
    >
      {children}
    </Box>
  ),
);

Flexbox.propTypes = {
  children: node.isRequired,
  className: string,
  /** Flex direction. */
  flexDirection: oneOf(['row', 'row-reverse', 'column', 'column-reverse']),
  /** Flex wrap. */
  flexWrap: oneOf([undefined, 'nowrap', 'wrap', 'wrap-reverse']),
  /** Justify content. */
  justifyContent: oneOf([
    'flex-start',
    'flex-end',
    'center',
    'space-between',
    'space-around',
    'space-evenly',
  ]),
  /** Align items. */
  alignItems: oneOf([
    'flex-start',
    'flex-end',
    'center',
    'stretch',
    'baseline',
    'space-evenly',
  ]),
  /** Align content. */
  alignContent: oneOf([
    'flex-start',
    'flex-end',
    'center',
    'space-between',
    'space-around',
    'stretch',
  ]),
  /** Order. */
  order: shape({}),
  /** Flex grow. */
  flexGrow: oneOfType([string, number, shape({})]),
  /** Flex shrink. */
  flexShrink: shape({}),
  /** Flex basis. */
  flexBasis: string,
  /** Align self. */
  alignSelf: shape({}),
  /** Column gap */
  columnGap: oneOfType([string, number]),
  /** Row gap */
  rowGap: oneOfType([string, number]),
};

Flexbox.defaultProps = {
  className: undefined,
  flexDirection: undefined,
  flexWrap: undefined,
  justifyContent: undefined,
  alignItems: undefined,
  alignContent: undefined,
  order: undefined,
  flexGrow: undefined,
  flexShrink: undefined,
  flexBasis: undefined,
  alignSelf: undefined,
  columnGap: undefined,
  rowGap: undefined,
};

export default Flexbox;
